<script setup>
import { computed, ref } from 'vue';
import NinaStandalone from '../../crm/nina/NinaStandalone.vue';
import CloserQuoteLeadSearch from '../../crm/nina/CloserQuoteLeadSearch.vue';

defineProps({
    exitUrl: { type: String, required: true },
    initialMessage: { type: String, default: '' },
});

const standaloneRef = ref(null);

const hasDomain = computed(() => Boolean(standaloneRef.value?.domain));
</script>

<template>
    <div class="flex flex-col h-screen bg-gray-50">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200">
            <div class="flex items-center gap-3">
                <button v-if="hasDomain" @click="standaloneRef.domain = null" class="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
                <a v-if="!hasDomain" :href="exitUrl">
                    <button-secondary>
                        <mf-translate domainkey="page:pagebuilder.exit"></mf-translate>
                    </button-secondary>
                </a>
                <div class="flex items-center gap-2">
                    <div class="w-8 h-8 rounded-full bg-aiAgentSalesAssistant flex items-center justify-center">
                        <ai-agent-sales-assistant-avatar class="w-full h-full" />
                    </div>
                    <div>
                        <h1 class="text-sm font-semibold text-gray-900">Closer</h1>
                        <p v-if="standaloneRef?.domain" class="text-xs text-gray-500 mb-0">{{ standaloneRef.domain }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Body -->
        <div class="flex-1 overflow-y-auto">
            <div class="max-w-5xl mx-auto px-4 py-6">
                <div :class="hasDomain ? '' : 'grid gap-4 md:grid-cols-2'">
                    <div :class="hasDomain ? '' : 'flex flex-col px-4 bg-white border border-gray-200 rounded-xl'">
                        <nina-standalone
                            ref="standaloneRef"
                            :initial-message="initialMessage"
                        />
                    </div>
                    <div v-if="!hasDomain" class="flex flex-col px-4 bg-white border border-gray-200 rounded-xl">
                        <closer-quote-lead-search />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
